export default function authHeader() {
    const jwtToken = localStorage.getItem('token');
  
    if (jwtToken) {
      const normalizedToken = jwtToken.startsWith('Bearer ')
        ? jwtToken.slice(7).trim()
        : jwtToken;
      return { 'Authorization': "Bearer " + normalizedToken };
    }
    return {};
  }